import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { ManagerState, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors((state: RootState): ManagerState => state.manager);

export default selectors;
